import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { finalize, switchMap, catchError } from 'rxjs/operators';
import { throwError, Observable, from, of } from 'rxjs';
import * as debug from '../services/debug.service';
import { SecurityService } from '../services/security.service';
import { appConfig, appUrl } from 'src/environments/environment';
import { MenuService } from '../services/menu.service';
import { fallbackMenu } from './utility.common';

@Injectable({ providedIn: 'root' })
export class NetworkInterceptor implements HttpInterceptor {

	constructor(private menuService: MenuService, private readonly router: Router
		, private readonly securityService: SecurityService
	) {
		debug.log('025 NetworkInterceptor instantiated');
	}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		debug.log('026 intercept isBusy = true');

		let forceNavigateToHome = false;

		this.menuService.setIsBusy(true);

		const isValidUrl = req.url.startsWith(appConfig.apiRoot);

		if (isValidUrl) {
			const isAnonymous = req.url.startsWith(appUrl.guestProfile);
			const securityServiceIsLoggedIn = from(this.securityService.isLoggedIn('027.1 NetworkInterceptor.isLoggedIn'));

			let isLoggedIn = false;

			return securityServiceIsLoggedIn.pipe(
				switchMap(loggedIn => {
					isLoggedIn = loggedIn;

					return from(this.securityService.getAccessToken());
				})
				, switchMap(token => {

					const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

					debug.log(`027.2 intercept headers BEFORE:`, req.headers);

					let authReq = req.clone({ headers });

					if (isAnonymous) {
						authReq = req;
					}

					debug.log(`027.3 intercept headers AFTER:`, authReq.headers);

					return next.handle(authReq);
				})
				, catchError(error => {

					this.menuService.setIsBusy(false);

					const respError = error as HttpErrorResponse;
					const isLoggerUrl = req.url.toLowerCase() === appConfig.logger;

					if (isLoggerUrl) {
						// ignore the call to log api and break endless loop
						forceNavigateToHome = true;
						return of(undefined);
					}

					if (respError && (respError.status === 0 || respError.status === 401 || respError.status === 403 || (respError.status >= 500 && respError.status <= 505))) {

						if (isLoggedIn) {

							debug.log(`027 intercept catchError navigating to unauthorized isLoggedIn: true`);

							const postLogoutMsg: Error = { name: 'Forced logout', message: `👨‍🔧Failed login due to 👉 ${respError.message} 📌status code: ${respError.status}` };

							return from(this.securityService.logout(postLogoutMsg));
							// return from(this.securityService.logout())
							// .pipe(
							// 	switchMap(() => {
							// 		return this.router.navigate(['/error'], { replaceUrl: true, state: { status: respError.status, errorMsg: respError.message } });
							// 	})
							// );

						} else {
							debug.log(`028 intercept catchError navigating to landing page isLoggedIn: false`);
							return this.router.navigate(['/']);
						}

					} else {
						const isProfileUrl = req.url.toLowerCase() === appUrl.userProfile || req.url.toLowerCase() === appUrl.userProfileImage;

						debug.log(`028.1 intercept catchError isProfileUrl:${isProfileUrl} respError.status:${respError.status} url: ${req.url} error:`, error);

						if (req.url.startsWith(appConfig.logger) || isProfileUrl) {

							// exclude and silently move on
							debug.log(`028.2 intercept catchError ignoring logger and userProfile error, silently moving on...`);

							forceNavigateToHome = true;

							if (req.url.toLowerCase() === appUrl.userProfile) {

								debug.log(`028.3 intercept catchError ignoring logger and userProfile error, returning fallbackMenu`, fallbackMenu);

								return of(fallbackMenu);

							} else {
								return of(undefined);
							}
						}

						debug.warn(`028.4 intercept catchError rethrowing error to GlobalErrorHandler`);

						return throwError(error); // let GlobalErrorHandler do its work
					}
				})
				, finalize(() => {

					debug.log('030 intercept isBusy = false');

					this.menuService.setIsBusy(false);

					if (forceNavigateToHome) {
						debug.log('030.1 Something went wrong. forceNavigateToHome..');
						return this.router.navigate(['/']);
					}
				})
			);
		}

		return next.handle(req);
	}
}
